/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';
import { Field } from 'formik';
import { CheckboxInput } from '@components';
import styles from './TPStep6.module.scss';

function TPStep6(): ReactElement {
  return (
    <div className={styles.step6}>
      <div className="vfH2">Declaration</div>
      <p>I declare that the information I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
      <p>I understand that it is my responsibility to ensure that the person I nominate is aware of what I am allowing them to do and any limitations I place on this authority.</p>
      <Field name="consentToDeclaration" component={CheckboxInput} title="I agree to the statements above" />
    </div>
  );
}

export default TPStep6;
